import { Node } from 'tiptap'

export default class ReplyQuote extends Node {

  get name() {
    return 'replyquote'
  }

  get schema() {
    return {
      content: 'block*',
      group: 'block',
      defining: true,
      draggable: false,
      parseDOM: [
        { tag: 'blockquote[class="reply-quote"]' },
      ],
      toDOM: () => ['blockquote', {class: 'reply-quote'}, 0],
    }
  }
}
